import React, { Fragment, useContext, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./styles/bootstrap.min.css";
import AuthContext from "./context/auth/authContext";
import Home from "./components/pages/Home";
import Video from "./components/pages/Video";
import Videos from "./components/pages/Videos";
import Register from "./components/Auth/Register";
import Login from "./components/Auth/Login";
import AccountHome from "./components/pages/AccountHome";
import Error404 from "./components/pages/Error404";
import Collection from "./components/collections/Collection";
import AppRoute from "./components/AppRoute";
import HomeTemplate from "./components/templates/HomeTemplate";
import AuthTemplate from "./components/templates/AuthTemplate";
import AccountTemplate from "./components/templates/AccountTemplate";
import VideoTemplate from "./components/templates/VideoTemplate";
import Choose from "./components/pages/Choose";
import ChangePass from "./components/pages/account/ChangePass";
import ReAuthenticate from "./components/Auth/ReAuthenticate";
import EditAccount from "./components/pages/account/EditAccount";
import ResetPass from "./components/pages/account/ResetPass";
import ClassEdit from "./components/editprofs/ClassEdit";
const App = () => {
  const authContext = useContext(AuthContext);
  useEffect(() => {
    authContext.loadUser();
    //eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <Router>
        <Switch>
          <AppRoute exact path='/' layout={HomeTemplate} component={Home} />
          <AppRoute
            path='/videos/:query'
            layout={HomeTemplate}
            component={Videos}
          />
          <AppRoute
            path='/account/:type/:uid'
            layout={AccountTemplate}
            component={Videos}
          />

          <AppRoute
            exact
            path='/:collection/:type/:id'
            layout={VideoTemplate}
            component={Video}
          />

          <AppRoute
            exact
            path='/register'
            layout={AuthTemplate}
            component={Register}
          />
          <AppRoute
            exact
            path='/login'
            layout={AuthTemplate}
            component={Login}
          />
          <AppRoute
            exact
            path='/uplode'
            layout={HomeTemplate}
            component={Choose}
          />

          <AppRoute
            exact
            path='/academics/:collection'
            layout={HomeTemplate}
            component={Collection}
          />
          <AppRoute
            exact
            path='/extracurriculars/:collection'
            layout={HomeTemplate}
            component={Collection}
          />
          <AppRoute
            exact
            path='/youtube/:collection'
            layout={HomeTemplate}
            component={Collection}
          />

          <AppRoute
            exact
            path='/classedit'
            component={ClassEdit}
            layout={HomeTemplate}
          />
          <AppRoute
            exact
            path='/viewaccount/:uid'
            layout={AccountTemplate}
            component={AccountHome}
          />

          <AppRoute
            exact
            path='/editaccount'
            layout={AccountTemplate}
            component={EditAccount}
          />
          <AppRoute
            path='/account/changepass'
            layout={AuthTemplate}
            component={ChangePass}
          />
          <AppRoute
            path='/resetPass'
            layout={AuthTemplate}
            component={ResetPass}
          />
          <AppRoute
            path='/reauthenticate/:redirect'
            layout={AuthTemplate}
            component={ReAuthenticate}
          />

          <AppRoute layout={AuthTemplate} component={Error404} />
        </Switch>
      </Router>
    </Fragment>
  );
};

export default App;
